import { AxiosRequestConfig } from 'axios'

import { ASYNC_STORAGE_KEYS } from '~constants'
import { secureStore } from '~utils'

export const injectRefreshTokenToRequest = async (config: AxiosRequestConfig<object>) => {
  const refreshToken = await secureStore.getItem(ASYNC_STORAGE_KEYS.USER_REFRESH_TOKEN)

  let Authorization = ''
  if (refreshToken) {
    Authorization = `Bearer ${refreshToken}`
  }
  return {
    ...config,
    headers: {
      Authorization,
      ...config?.headers,
    },
  }
}
